/*
Elegance Compare Plugin JS
Author: https://elegancedesign.net/
*/
jQuery(document).ready(function($) {

	var $ajax_url = compare_variables.ajax_url;

	if($('#bonus-range').length && $('#range-bonus-value').length && $('#games-range').length && $('#range-games-value').length ) {
		var bonus_range = document.getElementById('bonus-range');
		var bonus_range_value = document.getElementById('range-bonus-value');
		var games_range = document.getElementById('games-range');
		var games_range_value = document.getElementById('range-games-value');
		
		ranges();
		compareFilter();
		searchKeyUP();
	}

	$("body").on('click', '.elegance-compare, .add-compare', function() {

		var $this = $(this);
		var $id = $(this).data('post-id');
		var $modal = $(this).data('modal');
		var $modal_holder = $('#elegance-compare-holder');
		var $add_compare_list = false;

		if( $modal ) {
			$modal_holder.fadeIn();

			if( !$modal_holder.hasClass( '' + $id ) ) {

				$modal_holder.addClass( '' + $id );
						
				$.ajax({
					url: $ajax_url,
					type: 'POST',
					data: {
						action: 'open_compare',
						compare_post_id: $id,
					},
					beforeSend: function () {
						$('#elegance-compare-holder .container').empty();
					},
					success: function (response) {
						$(response).appendTo('#elegance-compare-holder .container');
						bonus_range = document.getElementById('bonus-range');
						bonus_range_value = document.getElementById('range-bonus-value');
						games_range = document.getElementById('games-range');
						games_range_value = document.getElementById('range-games-value');
						ranges();
						compareFilter();
						searchKeyUP();
						filterSize();
					}
				});
			}
		}
		else if( $('th[class^="compare-col-"]').length < 5 ) {
			$(".limited").addClass('d-none');

			if( ! $('.compare-col-' + $id).length ) {

				$add_compare_list = ($this.hasClass('elegance-compare')) ? false : true;

				$.ajax({
					url: $ajax_url,
					type: 'POST',
					data: {
						action: 'add_compare',
						compare_post_id: $id,
						add_compare_list: $add_compare_list
					},
					beforeSend: function() {
						$('.compare-results .alert-warning').remove();
						$('.compare-results').addClass('results-loading');
					},
					success: function (response) {
						if($this.hasClass('elegance-compare')) {
							window.location.href = '/' + response;
						}
						else {
							$(".compare-table").remove();

							$(response).appendTo('.compare-results');
							$('.compare-results').removeClass('results-loading');
							filterSize();
						}
					}
				});
			}
		}
		else {
			$(".limited").removeClass('d-none');
		}

		return false;
	});
	

	$("body").on('click', '.remove-compare', function() {

		var $id = $(this).data('post-id');

		$('.compare-col-' + $id).fadeOut(400);

		setTimeout(function(){
			$('.compare-col-' + $id).remove();
			filterSize();
		}, 401);

		$.ajax({
			url: $ajax_url,
			type: 'POST',
			data: {
				action: 'remove_compare',
				compare_post_id: $id
			},
			success: function() {
				$(".limited").addClass('d-none');
			}
		});

		return false;
	});

	$('.elegance-compare-bg').click(function() {
		$('#elegance-compare-holder').fadeOut();
	});

	function compareFilter() {
		$('.compare-item').each(function(i, e) {
			$this = $(e);

			var search_value = $("#compareSearch").val().toLowerCase();
			var item_title = $this.data('title').toLowerCase();
			var item_bonus = parseInt($this.data('bonus'));
			var item_games = parseInt($this.data('games'));
			var bonus_range_set = parseInt(bonus_range.noUiSlider.get());
			var games_range_set = parseInt(games_range.noUiSlider.get());

			if( !search_value )	{
				if( item_bonus <= bonus_range_set && item_games <= games_range_set ) {
					$this.fadeIn(400);
				} else {
					$this.fadeOut(400);
				}
			} else {
				if( item_title.indexOf(search_value) != -1 && item_bonus <= bonus_range_set && item_games <= games_range_set ) {
					$this.fadeIn(400);
				} else {
					$this.fadeOut(400);
				}
			}
		});
	}

	function searchKeyUP() {
		$('#compareSearch').keyup(function() {
			compareFilter();
		});
	}

	function ranges () {

		noUiSlider.create(bonus_range, {
			start: parseInt(compare_variables.bonus_max_value),
			step: parseInt(compare_variables.bonus_step),
			connect: [true, false],
			range: {
				'min':  parseInt(compare_variables.bonus_min_value),
				'max':  parseInt(compare_variables.bonus_max_value)
			},
			format: wNumb({
				decimals: 0,
				postfix: ' ' + compare_variables.bonus_prefix,
			})
		});


		bonus_range.noUiSlider.on('update', function( values, handle ) {
			bonus_range_value.innerHTML = values[handle];
		});

		bonus_range.noUiSlider.on('slide', function(){
			compareFilter();
		});


		noUiSlider.create(games_range, {
			start: parseInt(compare_variables.games_max_value),
			step: parseInt(compare_variables.games_step),
			connect: [true, false],
			range: {
				'min':  parseInt(compare_variables.games_min_value),
				'max':  parseInt(compare_variables.games_max_value)
			},
			format: wNumb({
				decimals: 0
			})
		});


		games_range.noUiSlider.on('update', function( values, handle ) {
			games_range_value.innerHTML = values[handle];
		});

		games_range.noUiSlider.on('slide', function(){
			compareFilter();
		});
	}

	function filterSize() {
		var $ct = $(".compare-table").outerHeight();
		var $fh = $(".compare-finder").outerHeight();
		$(".compare-filters-results").height($ct - $fh);
	}
});
